<script setup lang="ts">
import { computed } from 'vue'
import BasicSpinnerDefault from './BasicSpinner.default.vue'

import { brand } from '@/config/brands'
import { loadBrandComponent } from '@/utils/loadBrandConfig'

const isFlipnovelFamily = ['flipnovel', 'storlyn', 'moonpage', 'novaris', 'novelune'].includes(brand)
// NovelMello 用纯 CSS ring（颜色取 --loading-spinner-color = 主色 #F0509B），不依赖 spinner 图片
const useRingSpinner = computed(() => isFlipnovelFamily || brand === 'aurenovel' || brand === 'novelmello')
const spinnerSize = computed(() => useRingSpinner.value ? '32px' : '40px')

const SpinnerComponent = loadBrandComponent({ rocnovel: BasicSpinnerDefault })
</script>

<template>
  <div class="spinner" :style="{ width: spinnerSize, height: spinnerSize }">
    <component :is="SpinnerComponent" />
  </div>
</template>

<style scoped>
.spinner {
  display: inline-block;
}
</style>
